module.exports = __webpack_public_path__ + "img/BocataVitoriana_blur.5fd3b852.jpg";